import { Link } from 'react-router-dom'
import ScreenHolder from '../../Partials/Layouts/ScreenHolder/ScreenHolder'

function OrganizationGroupScreens() {
  return (
    <ScreenHolder>
        <div>
        <div>
          <Link to={'/categories'} >Categories</Link>
        </div>
        <div>
          <Link to={'/featuredCategories'} >Featured Categories</Link>
        </div>
        <div>
          <Link to={'/subcategories'} >Subcategories</Link>
        </div>
      </div>
    </ScreenHolder>
  )
}

export default OrganizationGroupScreens